import { GenericProductCards } from "@/assets/constants/analysisCards";
import { GLOBAL_EVENTS } from "@/assets/constants/eventsDates";
import { UpdateFrequency } from "@/assets/constants/frequencies";
import {
  STANDARD_PERF_STATS_WITH_BENCHMARK,
  STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
} from "@/assets/constants/perfStats";
import { STANDARD_ZOOM_BUTTONS } from "@/assets/constants/zoomButtons";
import exports from "@/assets/scss/exports.module.scss";

const ORG_COLOR = exports["colors-primary"];

const preciousCapitalGlobalMiningMetalsFundClass1Chf = {
  productId: "precious-capital-global-mining-metals-fund-class-1-chf",
  storeModule: "preciousCapitalGlobalMiningMetalsFundClass1Chf",
  productName: "Precious Capital Global Mining and Metals Fund Class 1 (CHF)",
  productColor: ORG_COLOR,
  langsForDocuments: ["en", "de"],
  live: {
    updateFrequency: UpdateFrequency.daily,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
    ],
    perfStats: STANDARD_PERF_STATS_WITH_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet" },
      needLoginToSee: false,
    },
  ],
};

const gotthardStrategicFundIChf = {
  productId: "gotthard-strategic-fund-i-chf",
  storeModule: "gotthardStrategicFundIChf",
  productName: "Gotthard Strategic Fund I (CHF)",
  productColor: ORG_COLOR,
  langsForDocuments: ["en", "de"],
  live: {
    updateFrequency: UpdateFrequency.daily,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet" },
      needLoginToSee: false,
    },
  ],
};

export const PRODUCTS_DETAILS = [
  preciousCapitalGlobalMiningMetalsFundClass1Chf,
  gotthardStrategicFundIChf,
];

export const PRODUCTS = PRODUCTS_DETAILS.map((details) => details.storeModule);
